import { load } from '@shopify/theme-sections';

import katiesStory from '../sections/katies-story';

if (document.body.classList.contains('template-page')) {
  if (document.body.id === 'help') {
    katiesStory().init();

    // Userway Custom Trigger
    document.getElementById('uwTrigger').addEventListener('click', () => {
      UserWay.widgetToggle();
    });

    load('*');
  }
}
